import { observer } from "mobx-react";
import { Dialog, DialogContent } from "@mui/material";

const ViewImgModal = observer(({ img, show, setShow }) => {
    return (
        <Dialog fullWidth maxWidth='md' open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px', textAlign: 'center' }, variant: 'round' }}
        >
            <DialogContent sx={{ textAlign: 'center' }}>
                <img src={img} alt='personal img' style={{display: 'block', width: '90%', maxWidth: '350px', margin: '0 auto'}} />
            </DialogContent>
        </Dialog>
    );
});

export default ViewImgModal;
